'use client'

// src/constants/cookies.ts
var CONSENT_COOKIE_NAME = "cookie_consent";
var CHECKOUT_DATA_COOKIE_NAME = "checkout_data";
var USER_DATA_STORAGE_KEY = "user_data";

export {
  CONSENT_COOKIE_NAME,
  CHECKOUT_DATA_COOKIE_NAME,
  USER_DATA_STORAGE_KEY
};
//# sourceMappingURL=chunk-T2NN7R53.mjs.map